import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react';
import styles from './OrbitElementSimulator.module.scss';
import Orbits3D from "./Orbits3D/Orbits3D";
import SegmentedSlider from "../SegmentedSlider/SegmentedSlider";
import SummaryBox from "./SummarBox/SummaryBox";
import Button from "../../../partials/Button";
import GroundData from "../GroundData/GroundData";
import { OrbitsContext } from "../Context/OrbitsContext";
import ContentBox from "../common/ContentBox/ContentBox";

var DO_ALTITUD_SLIDER_ON_CHANGE = false;

function OrbitElementsSimulator({
  doAltitude = false,
  orbit,
  perigee = 0,
  sma = 0,
  inc = 0,
  ecc = 0,
  isSingleSlider,
  singleSliderValues,
  onSingleSelectChange = () => { },
  SMAValues = [],
  InclinationValues = [],
  EccentricityValues = [],
  showSliders = true,
  showSummary = true,
  showGroundData = true,
  onSlidersChange = () => { },
  onSliderClick = () => { },
  orbitColor,
  errorMsg,
  onErrorClick = () => { },
  sliderCaptions = ['SMA', 'INCLINATION', 'ECCENTRICITY'],
  width = "100%", height = "100%" }) {
  const orbitsState = React.useContext(OrbitsContext)
  const earthRadius = 6371
  const KmInPoints = 0.00039240307; // 2.5/6371.0
  const [currentCamera, setCurrentCamera] = React.useState(10);

  const [currentSMA, setCurrentSMA] = React.useState(() => sma);
  const [currentInclination, setCurrentInclination] = React.useState(() => inc)
  const [currentEccentricity, setCurrentEccentricity] = React.useState(() => ecc);
  const [currentPerigee, setCurrentPerigee] = React.useState(perigee)


  const [altitudeValues, setAltitudeValues] = useState([])

  const [currentRa, setCurrentRa] = React.useState()
  const [currentRp, setCurrentRp] = React.useState()

  const [isGood, setIsGood] = React.useState({
    good: true,
    reason: ''
  })

  const singleValues = isSingleSlider && Array.isArray(singleSliderValues) ? singleSliderValues.map(v => v.value) : []
  const [currentSingleValue, setCurrentSingleValue] = React.useState()
  const [reset, setReset] = React.useState(false)

  React.useEffect(() => {
    return () => {
      if (doAltitude === true) DO_ALTITUD_SLIDER_ON_CHANGE = false
    }
  }, [doAltitude])

  React.useEffect(() => {
    if (!orbit || !orbitsState) {
      return
    }
    const av = (function () {
      try {
        const orbitGroundData = orbitsState.groundData[orbit.header.toLowerCase()]
        console.log(orbitsState)
        console.log(orbit)
        console.log(orbitGroundData)
        const aspectValues = [...new Set(orbitGroundData.map(d => d['rp']))]
        return aspectValues.sort(function (a, b) {
          return a - b
        })

      } catch (e) {
        console.log(e)
      } finally {
      }
      return [];
    })();
    setAltitudeValues(av)
  }, [orbit, orbitsState])


  React.useEffect(() => {

    if (!orbit || !orbitsState) {
      return
    }
    const bInPoints = calculateBinPoints(smaToPoints(currentSMA), currentEccentricity);
    const altPoints = smaToPoints(currentSMA)
    const fociPoints = calculateFociPoints(currentSMA, bInPoints)
    // Original calculations
    // setOrbit1({
    //   ...orbit1,
    //   xRadius: altPoints,
    //   zRadius: bInPoints,
    //   offsetX: fociPoints,
    //   offsetY: 0,//calculateBinPoints(smaToPoints(currentSMA), currentEccentricity),
    //   rotateZ: currentInclination // Change this for inclination
    // })

    if (onSlidersChange) {
      if (doAltitude === true) {
        if (DO_ALTITUD_SLIDER_ON_CHANGE === false) {
          onSlidersChange({
            pr: currentPerigee,
            sma: currentSMA,
            eccentricity: currentEccentricity,
            inclination: currentInclination
          });
        }
      } else {
        onSlidersChange({
          pr: currentPerigee,
          sma: currentSMA,
          eccentricity: currentEccentricity,
          inclination: currentInclination
        });
      }
    }

    console.log(" update state", currentPerigee, currentSMA, currentEccentricity, currentInclination)

    const currentOrbitData = orbitsState.groundData[orbit.header.toLowerCase()]
      .find(o => doAltitude ? o.rp : o.sma === (doAltitude ? currentPerigee : currentSMA)
        && o.ecc === currentEccentricity && o.inc === currentInclination
      )

    if (!currentOrbitData) {
      console.warn("No ground data for: ", currentPerigee, currentSMA, currentEccentricity, currentInclination)
      setOrbit2({
        xRadius: smaToPoints(currentSMA),
        zRadius: smaToPoints(currentSMA) * Math.sqrt((1 - currentEccentricity * currentEccentricity)),
        offsetX: fociPoints,
        offsetY: 0,
        rotateZ: currentInclination // Change this for inclination
      })
      return;
    }

    setCurrentRa(currentOrbitData?.ra)
    setCurrentRp(currentOrbitData?.rp)

    if (doAltitude === true) {
      const theSMA = currentOrbitData.sma;

      if (DO_ALTITUD_SLIDER_ON_CHANGE === false)
        DO_ALTITUD_SLIDER_ON_CHANGE = true;
      else 
        DO_ALTITUD_SLIDER_ON_CHANGE = false;

      setCurrentSMA(theSMA)
      setCurrentEccentricity(currentOrbitData.ecc)

      setOrbit2({
        xRadius: smaToPoints(theSMA),
        //  zRadius: smaToPoints(theSMA) * Math.sqrt((1 - currentEccentricity* currentEccentricity)) ,
        zRadius: smaToPoints(theSMA) * Math.sqrt((1 - currentOrbitData.ecc * currentOrbitData.ecc)),
        offsetX: fociPoints,
        offsetY: 0,
        rotateZ: currentInclination // Change this for inclination
      });

    } else {
      setOrbit2({
        xRadius: smaToPoints((currentOrbitData?.ra + currentOrbitData?.rp) / 2),
        zRadius: smaToPoints(currentSMA) * Math.sqrt((1 - currentEccentricity * currentEccentricity)),
        offsetX: fociPoints,
        offsetY: 0,
        rotateZ: currentInclination // Change this for inclination
      })
    }

  }, [currentPerigee, currentSMA, currentInclination, currentEccentricity])



  React.useEffect(() => {
    if (smaToPoints(currentSMA) > 6) {
      setCurrentCamera(smaToPoints(currentSMA) * 2.6)
    }
  }, [currentSMA])

  // React.useEffect(() => {
  //   if (onSlidersChange) {
  //     onSlidersChange({
  //       pr: currentPerigee,
  //       sma: currentSMA,
  //       eccentricity: currentEccentricity,
  //       inclination: currentInclination
  //     })
  //   }
  // }, [currentPerigee, currentSMA, currentInclination, currentEccentricity ])

  const smaToPoints = (sma) => {
    //return (earthRadius + sma) * KmInPoints
    return sma * KmInPoints
  }
  // Receives sma in points and eccentricity
  const calculateBinPoints = (altP, ecc) => {
    return Math.sqrt((Math.pow(altP, 2) - Math.pow(altP * ecc, 2)))
  }
  const calculateFociPoints = (sma, b) => {
    return Math.sqrt(Math.pow(smaToPoints(sma), 2) - Math.pow(b, 2))
  }

  const [orbit1, setOrbit1] = React.useState({
    xRadius: smaToPoints(currentSMA),
    zRadius: smaToPoints(currentSMA),
    offsetX: 0,
    offsetY: 0, //calculateBinPoints(smaToPoints(currentSMA), currentEccentricity),
    rotateX: 0,
    rotateY: 0,
    rotateZ: -0 // Change this for inclination
  });
  const [orbit2, setOrbit2] = React.useState({
    xRadius: smaToPoints(currentSMA),
    zRadius: smaToPoints(currentSMA),
    offsetX: 0,
    offsetY: 0, //calculateBinPoints(smaToPoints(currentSMA), currentEccentricity),
    rotateX: 0,
    rotateY: 0,
    rotateZ: -0 // Change this for inclination
  });
  React.useEffect(() => {
    console.log('orbits2', orbit2)
  }, [orbit1, orbit2])

  return <div className={styles.OrbitElementsSimulator} >
    <div className={styles.Orbits}>
      {showSummary === true && <SummaryBox
        sma={currentSMA}
        inclination={currentInclination}
        eccentricity={currentEccentricity}
      />}
      {!reset && <Orbits3D orbits={[orbit2]} camera={currentCamera} orbitColor={orbitColor} />}
    </div>

    {errorMsg && <div className={styles.ErrorBox} onClick={() => onErrorClick()}>
      <ContentBox variant={'failure'} fitContent={true} title={'Orbit Feedback'} >
        <p>{errorMsg}</p>
      </ContentBox>
    </div>
    }
    {
      showSliders === true && isSingleSlider === true && singleValues && <div className={`${styles.Sliders} ${styles.single}`}><div className={styles.Slider}>
        <SegmentedSlider caption={orbitsState?.config?.singleSliderCaption || 'Select an option'}
          variant={'single'}
          values={singleValues}
          onChange={(e) => {
            setCurrentSingleValue(e)
            onSingleSelectChange(e)
          }}
        >

        </SegmentedSlider>
      </div></div>
    }
    {showSliders === true && isSingleSlider !== true && <div className={styles.Sliders}>
      <div className={styles.Slider}>
        {doAltitude === false && <SegmentedSlider
          className={styles.SingleSlider}
          defaultValue={SMAValues.indexOf(currentSMA)}
          variant={'slim'}
          caption={sliderCaptions[0] || 'sma'}
          values={[...Array(SMAValues.length).keys()]}
          onChange={(i) => {
            setCurrentSMA(SMAValues[i])
            onSliderClick('sma')
          }} />}
        {doAltitude === true && <SegmentedSlider
          className={styles.SingleSlider}
          defaultValue={altitudeValues.indexOf(currentPerigee)}
          variant={'slim'}
          caption={'Perigee Radius'}
          values={[...Array(altitudeValues.length).keys()]}
          onChange={(i) => {
            console.log('SETTING PERIGEE RADIUS TO:', altitudeValues[i])
            setCurrentPerigee(altitudeValues[i])
            onSliderClick('pr')
          }} />}
      </div>

      <div className={styles.Slider}>
        <SegmentedSlider
          defaultValue={InclinationValues.indexOf(currentInclination)}
          variant={'slim'}
          caption={sliderCaptions[1] || 'ECCENTRICITY'} values={[...Array(InclinationValues.length).keys()]} onChange={(i) => {
            setCurrentInclination(InclinationValues[i])
            onSliderClick('inclination')
          }} />
      </div>
      <div className={styles.Slider}>
        <SegmentedSlider
          variant={'slim'}
          defaultValue={EccentricityValues.indexOf(currentEccentricity)}
          caption={sliderCaptions[2] || 'ECCENTRICITY'} values={[...Array(EccentricityValues.length).keys()]}
          onChange={(i) => {
            setCurrentEccentricity(EccentricityValues[i])
            onSliderClick('eccentricity')
          }} />
      </div>
    </div>}
    <div className={styles.GroundTracks}>
      {showGroundData === true && <GroundData
        orbit={orbit}
        doMercator={true}
        highlightCoord={isSingleSlider && currentSingleValue ? { lon: currentSingleValue, lat: 0 } : null}
        doCircles={orbitsState?.options?.groundTracksDoDots === true}
        dotsColor={orbitsState?.options?.groundTrackDotsColor || 'red'}
        doCurves={orbitsState?.options?.groundTrackSmoothLines === true}
        orbitsJsonFile={`json/${orbitsState.currentSelectedOrbit.header.toLowerCase()}.json`}
        ecc={currentEccentricity}
        inc={currentInclination}
        sma={currentSMA} />}
    </div>
  </div>
}

export default OrbitElementsSimulator;

OrbitElementsSimulator.propTypes = {
  ecc: PropTypes.number,
  height: PropTypes.string,
  inc: PropTypes.number,
  sma: PropTypes.number,
  width: PropTypes.string
}

OrbitElementsSimulator.defaultProps = {
  ecc: 0.0,
  height: "100%",
  inc: 0,
  sma: 7478,
  width: "100%"
}
